module.exports = __webpack_public_path__ + "static/bg3-e6299b3babc7d2c5eebbae2f68ee9b13.png";